import config from '../../config';

/** Every column the suppliers table knows how to render. */
export type SupplierColumnId = 'gln' | 'name' | 'status' | 'plan' | 'addons' | 'connectors' | 'createdAt' | 'actions';

/**
 * Which columns each deployment renders, and in what order. Single source of
 * truth: `SupplierList` derives its react-table config from this and nothing
 * else decides whether a column appears.
 *
 * No widths: `Table` renders `<table class="w-full">` without `table-fixed`, so
 * the browser sizes columns from their content. Long values wrap rather than
 * widening their column, since the cell uses `break-words`.
 *
 * The per-deployment difference is structural, not cosmetic:
 * - GS1 has no add-ons catalog; its extra dashboards are `custom_dashboard_ids`.
 * - Logyca suppliers have no connector credentials.
 */
export const GS1_SUPPLIER_COLUMNS: SupplierColumnId[] = [
  'gln',
  'name',
  'status',
  'plan',
  'connectors',
  'createdAt',
  'actions',
];

export const LOGYCA_SUPPLIER_COLUMNS: SupplierColumnId[] = [
  'gln',
  'name',
  'status',
  'plan',
  'addons',
  'createdAt',
  'actions',
];

/**
 * The suppliers page only exists for gs1 and logyca — the backend's
 * `get_supplier_resolver` rejects any other flavor, since `bops` has no
 * supplier concept. GS1 is therefore the fallback for a local build with
 * `REACT_APP_FLAVOR` unset.
 */
export const getSupplierColumns = (): SupplierColumnId[] =>
  config.isLogycaFlavor ? LOGYCA_SUPPLIER_COLUMNS : GS1_SUPPLIER_COLUMNS;
